import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLivePaidEmdOfferForService } from "../../../../../../redux/action/liveRoom";
import { useNavigate, useParams } from "react-router-dom";
import {
  calculateRemainingTime,
  formatTime,
} from "../../../../../../helpers/helpers";

function MobileServiceHeader({ singleAuctionData }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state?.profileStore);
  const { ListLoadings } = useSelector((state) => state.liveAuctionList);

  const refershInLiveRoom = () => {
    dispatch(getLivePaidEmdOfferForService(id));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const newRemainingTime = calculateRemainingTime(
        singleAuctionData?.auctionSchedule?.endingTime
      );

      if (formatTime(newRemainingTime) <= "00:00:00") {
        navigate("/thanks-for-participation");
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [singleAuctionData, navigate]);

  return (
    <div
      className="cercle-purple white-text border-radius-12 valign-wrapper gap-1 space-between"
      style={{ padding: "10px 14px" }}
    >
      <p>Welcome : {profile?.email}</p>
      <span className="valign-wrapper gap-1">
        <span
          className="material-symbols-outlined font-25px pointer"
          onClick={() => window.close()}
        >
          logout
        </span>
        <span
          className="material-symbols-outlined font-25px pointer"
          disabled={ListLoadings}
          onClick={refershInLiveRoom}
        >
          autorenew
        </span>
      </span>
    </div>
  );
}

export default MobileServiceHeader;
